import { DiscountType, SalesIncentiveType } from "@utils/enums";

import { ProductCashBackPromotion } from "@components/Product/ECommerce/eCommerce.types";

import { ProductPromotion } from "lib/@types/service/product/shared";

const getDiscountType = (promotion: ProductPromotion): DiscountType | null => {
    if (promotion && promotion.promotionValue) return DiscountType.ABSOLUTE;
    if (promotion && promotion.promotionPercent) return DiscountType.PERCENTAGE;

    return null;
};

const getCashbackPromotion = (
    promotions: ProductPromotion[] = [],
): ProductCashBackPromotion | null => {
    const cashbackPromotion = promotions.filter(
        (p: ProductPromotion) =>
            p.promotionType === SalesIncentiveType.Cashback,
    )[0];

    const cashbackUnit = getDiscountType(cashbackPromotion);
    const cashbackAmount =
        cashbackUnit === DiscountType.ABSOLUTE
            ? cashbackPromotion?.promotionValue
            : cashbackPromotion?.promotionPercent;

    return cashbackPromotion
        ? ({
              ...cashbackPromotion,
              cashbackUnit,
              cashbackAmount,
          } as ProductCashBackPromotion)
        : null;
};

const promotionMapper = (promotion: ProductPromotion): ProductPromotion => {
    const discountType = getDiscountType(promotion);
    const {
        promotionCode,
        promotionType,
        promotionValue,
        promotionPercent,
        marketingText,
        validFrom,
        validTo,
        periodText,
    } = promotion;

    return {
        promotionCode,
        promotionType,
        promotionValue,
        promotionPercent,
        marketingText,
        validFrom,
        validTo,
        discountType,
        periodText,
    };
};

export { getCashbackPromotion, getDiscountType, promotionMapper };
